import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=8dd8fe5a&scoped=true&"
import script from "./TableLayout.vue?vue&type=script&lang=js&"
export * from "./TableLayout.vue?vue&type=script&lang=js&"
import style0 from "./TableLayout.vue?vue&type=style&index=0&id=8dd8fe5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd8fe5a",
  null
  
)

export default component.exports